var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "the-loop-wrapper" }, [
    _vm.posts.length > 0
      ? _c("div", [
          _c(
            "ul",
            { staticClass: "the-loop" },
            _vm._l(_vm.posts, function (post) {
              return _c("li", { key: post.id }, [
                _c(
                  "div",
                  { staticClass: "title" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { name: "post", params: { slug: post.slug } },
                        },
                      },
                      [_vm._v(_vm._s(post.title.rendered))]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "meta" },
                  [
                    _vm._v("Categories:"),
                    _vm._l(post.cats, function (cat, index) {
                      return _c(
                        "router-link",
                        {
                          key: cat.id,
                          attrs: {
                            to: {
                              name: "category",
                              params: { category: cat.slug },
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(cat.name)),
                          index < post.cats.length - 1
                            ? _c("span", [_vm._v(", ")])
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c("div", {
                  staticClass: "excerpt",
                  domProps: { innerHTML: _vm._s(post.excerpt.rendered) },
                }),
              ])
            }),
            0
          ),
          _vm.pagers.length > 1
            ? _c(
                "ul",
                { staticClass: "pagination" },
                _vm._l(_vm.pagers, function (pager, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "page-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "page-link",
                          attrs: {
                            to: {
                              path: _vm.$route.fullPath,
                              query: { page: pager },
                            },
                          },
                        },
                        [_vm._v(_vm._s(pager))]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ])
      : _c("div", [_c("no-post")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }